import { useState } from 'react';
import { Greybg, ReadMoreReplies } from './styled';
import UserQuestion from '../UserQuestion';
import { images } from '../../../Constants/ImageUrls';
import { googlePlayStoreLink } from '../../../Constants/branchUrls';
import QAnswer from '../QAnswer.jsx';
import Loader from '../../Loader';
import { clicked_cta_event } from '../../../Utils/questionUtils';

export default function ColumnSix(props) {
  const {
    data,
    primaryCategory,
    // installLink,
    installAppLink,
    contentId,
    contentType,
    contentData,
    postData,
  } = props;
  const [loadCount, setLoadCount] = useState(2);
  const [showLoader, setShowLoader] = useState(false);

  const comments_count = data?.comments?.length;
  const comments = data?.comments;
  let most_helpful_comment_index = -1;

  for (let index = 0; index < comments_count; index++) {
    if (
      comments[index]?.state === 'accepted' ||
      comments[index]?.state === 'suggested'
    ) {
      most_helpful_comment_index = index;
      break;
    }
  }

  return (
    <div>
      <UserQuestion
        data={data}
        primaryCategory={primaryCategory}
        comments_count={comments_count}
        postData={postData}
      />
      <Greybg>
        {comments?.map((element, index) => {
          if (index < loadCount) {
            return (
              <QAnswer
                installLink={googlePlayStoreLink}
                key={index}
                data={element}
                contentId={contentId}
                allComments={data?.comments}
                loadCount={loadCount}
                postData={postData}
                most_helpful_comment_index={
                  most_helpful_comment_index === index
                }
              />
            );
          }
        })}
        {comments_count > loadCount && (
          <div className="ansloadmoreButton">
            <ReadMoreReplies
              onClick={() => {
                setShowLoader(true);
                setTimeout(() => {
                  setLoadCount((prev) => prev + 6);
                  setShowLoader(false);
                }, [1000]);
                clicked_cta_event(
                  'Comments',
                  'Read More Answers',
                  '',
                  '',
                  'cta',
                  postData?.content_id,
                  postData?.object_id,
                );
              }}
            >
              <p>
                Read More Answers{' '}
                <span className="light">({comments_count - loadCount})</span>
              </p>
              <img loading="lazy" src={images.arrowDownForward} alt="arrow" />
            </ReadMoreReplies>
          </div>
        )}
        {showLoader && <Loader />}
      </Greybg>
    </div>
  );
}
